<template>
  <b-card no-body class="product-item-card w-100">

    <div class="produto-favorito-div">
      <button
        type="button"
        class="produto-favorito-btn"
        :class="{ 'produto-favorito-btn-active': this.favorito != 0 }"
        :aria-label="this.favorito == 0 ? 'Favoritar produto' : 'Remover dos favoritos'"
        @click.stop.prevent="alternarFavorito"
      >
        <svg
          class="produto-favorito-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            d="M12 3.25l2.54 5.15 5.68.83-4.11 4 .97 5.65L12 16.21l-5.08 2.67.97-5.65-4.11-4 5.68-.83L12 3.25Z"
          />
        </svg>
      </button>
    </div>
    <a
      :href="urlProduto"
      rel="noopener noreferrer"
      :title="this.titulo"
      target="_blank"
      @click="registrarSelecaoProduto"
      class="product-item-link"
    >
      <b-card-img
        class="product-item-img text-center"
        :src="this.url_foto"
        onerror="this.src='img/logo_produto.jpg'"
        top
      ></b-card-img>
    </a>

    <b-card-body class="product-item-card-body">
      <a
        :href="urlProduto"
        rel="noopener noreferrer"
        :title="this.titulo"
        target="_blank"
        @click="registrarSelecaoProduto"
        class="product-item-link"
      >
        <p class="product-item-title">{{ this.titulo }}</p>
        <div class="product-item-details">
          <span><span class="product-item-detail-label">Cód.</span> {{ this.codigo }}</span>
          <span><span class="product-item-detail-label">Múlt.</span> {{ this.multiplo }}</span>
        </div>
      </a>
    </b-card-body>

    <template v-slot:footer>
      <div v-if="!temCliente">
        <div class="product-item-see-prices-wrapper">
          <slot :name="'seeButton'">
            <button
              type="button"
              class="product-item-see-prices-btn"
              v-on:click="seeButton"
              :disabled="disabled"
            >
              <i class="fa fa-shopping-cart" aria-hidden="true"></i>
              <span>Ver Preços</span>
            </button>
          </slot>
        </div>
      </div>
      <div v-else>
        <div v-if="loadingPrices" class="mt-2 mb-2 text-center">
          <b-spinner
            variant="secondary"
            label="Buscando valores..."
            small
          ></b-spinner>
        </div>
        <div
          class="product-item-prices"
          :class="{
            'product-item-prices-aligned':
              temLinhaCarrinhoMga || temLinhaCarrinhoItj,
            'product-item-prices-single':
              temLinhaCarrinhoMga !== temLinhaCarrinhoItj,
          }"
        >
          <div
            v-if="temFilialMga"
            class="product-item-branch-wrapper product-item-branch-wrapper-mga"
          >
          <div
            v-if="
              (!loadingPrices && canAdd(1) && exibePrecoMga) ||
              (valida_estoque == 'S' && exibePrecoMga)
            "
            class="product-item-branch product-item-branch-mga"
          >
            <div class="product-item-branch-info">
              <span class="product-item-tax">
                <template v-if="pc_ipi_st.maringa > 0">
                  {{ pc_ipi_st.maringa }}% IPI + ST
                </template>
                <template v-else-if="pc_ipi.maringa > 0">
                  {{ pc_ipi.maringa }}% IPI
                </template>
              </span>
              <strong class="product-item-price">
                R$ {{ valor.maringa | money }}
              </strong>
              <span class="product-item-stock">
                estoque: <strong>{{ estoqueFilial(1) }}</strong>
              </span>
            </div>

            <input
              :id="'inputMga' + codigo"
              :value="formatQuantity(quantidadeMga)"
              class="product-item-quantity"
              type="text"
              inputmode="numeric"
              aria-label="Quantidade para Maringá"
              @input="onQuantityInput($event, 'quantidadeMga')"
              @keyup.enter="addMgaToCart"
            />

            <button
              :id="'buttonMga' + codigo"
              type="button"
              class="product-item-cart product-item-cart-mga"
              :disabled="quantidadeMga <= 0"
              aria-label="Adicionar ao carrinho de Maringá"
              @click="addMgaToCart"
            >
              <i :class="confirmMga ? 'fa fa-check fa-lg' : 'fa fa-shopping-cart fa-lg'"></i>
            </button>

            <span class="product-item-branch-name">MGA</span>
          </div>
          <div
            v-else-if="
              !loadingPrices && !canAdd(1) && exibePrecoMga && canAdd(2)
            "
            class="consulte-nos product-item-branch product-item-branch-mga"
          >
            <slot :name="'outOfStock'">
              <b-button size="sm" variant="danger">Consulte-nos</b-button>
              <span class="product-item-branch-name">MGA</span>
            </slot>
          </div>
          </div>

          <div
            v-if="temFilialItj"
            class="product-item-branch-wrapper product-item-branch-wrapper-itj"
          >
          <div
            v-if="
              (canAdd(2) && !loadingPrices && exibePrecoItj) ||
              (valida_estoque == 'S' && exibePrecoItj)
            "
            class="product-item-branch product-item-branch-itj"
          >
            <div class="product-item-branch-info">
              <span class="product-item-tax">
                <template v-if="pc_ipi_st.itj > 0">
                  {{ pc_ipi_st.itj }}% IPI + ST
                </template>
                <template v-else-if="pc_ipi.itj > 0">
                  {{ pc_ipi.itj }}% IPI
                </template>
              </span>
              <strong class="product-item-price">
                R$ {{ valor.itj | money }}
              </strong>
              <span class="product-item-stock">
                estoque: <strong>{{ estoqueFilial(2) }}</strong>
              </span>
            </div>

            <input
              :id="'inputItj' + codigo"
              :value="formatQuantity(quantidadeItj)"
              class="product-item-quantity"
              type="text"
              inputmode="numeric"
              aria-label="Quantidade para Navegantes"
              @input="onQuantityInput($event, 'quantidadeItj')"
              @keyup.enter="addItjToCart"
            />

            <button
              :id="'buttonItj' + codigo"
              type="button"
              class="product-item-cart product-item-cart-itj"
              :disabled="quantidadeItj <= 0"
              aria-label="Adicionar ao carrinho de Navegantes"
              @click="addItjToCart"
            >
              <i :class="confirmItj ? 'fa fa-check fa-lg' : 'fa fa-shopping-cart fa-lg'"></i>
            </button>

            <span class="product-item-branch-name">NAV</span>
          </div>
          <div
            v-else-if="
              !loadingPrices && !canAdd(2) && exibePrecoItj && canAdd(1)
            "
            class="consulte-nos product-item-branch product-item-branch-itj"
          >
            <slot :name="'outOfStock'">
              <b-button size="sm" variant="danger">Consulte-nos</b-button>
              <span class="product-item-branch-name">NAV</span>
            </slot>
          </div>
          </div>
        </div>
        <div
          v-if="
            !loadingPrices && !canAdd(1) && !canAdd(2) && valida_estoque == 'N'
          "
        >
          <b-row class="consulte-nos">
            <b-col class="text-center">
              <slot :name="'outOfStock'">
                <b-button size="sm" variant="danger"> Consulte-nos </b-button>
              </slot>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </b-card>
</template>
<style scoped>
.product-item-card {
  --product-action-color: #7c35e8;
  --product-action-color-hover: #6f2ed8;
  --product-card-radius: 8px;
  border-color: #d8e4f0;
  border-radius: var(--product-card-radius);
  overflow: hidden;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.product-item-card:hover {
  border-color: var(--product-action-color);
  box-shadow: 0 8px 18px rgba(124, 53, 232, 0.14);
}

.product-item-link {
  display: flex;
  height: 100%;
  flex-direction: column;
  color: #000;
  text-decoration: none;
}

.product-item-img {
  display: block;
  width: 229px;
  max-width: 100%;
  min-height: 8em;
  margin-right: auto;
  margin-left: auto;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  background-color: #f9f9f9;
  background-image: url("../../../../public/img/logo.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%;
}

.product-item-card-body {
  height: 96px;
  padding: 0.75rem 0.75rem 0.5rem;
}

.product-item-title {
  display: -webkit-box;
  overflow: hidden;
  min-height: calc(1.3em * 3);
  margin: 0;
  margin-bottom: 4px;
  color: #0c1733;
  font-size: 13px;
  line-height: 1.3;
  text-align: left;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.product-item-details {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  color: #172b4d;
  font-size: 12px;
  font-weight: 600;
}

.product-item-detail-label {
  color: #97a3b6;
  font-weight: 400;
}

::v-deep .card-footer {
  padding: 0 0.75rem 0.85rem;
  border-top: 0;
  border-radius: 0 0 7px 7px;
  background-color: #fff;
}

.product-item-see-prices-wrapper {
  width: 100%;
}

.product-item-see-prices-btn {
  display: inline-flex;
  width: 100%;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0.45rem 1rem;
  border: 1px solid var(--product-action-color);
  border-radius: 10px;
  background-color: var(--product-action-color);
  box-shadow: none;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}

.product-item-see-prices-btn:hover,
.product-item-see-prices-btn:focus {
  border-color: var(--product-action-color-hover);
  background-color: var(--product-action-color-hover);
  box-shadow: 0 4px 10px rgba(124, 53, 232, 0.2);
  color: #fff;
  outline: 0;
}

.product-item-see-prices-btn:not(:disabled):active {
  border-color: var(--product-action-color-hover);
  background-color: var(--product-action-color-hover);
  box-shadow: 0 2px 6px rgba(124, 53, 232, 0.18);
  transform: translateY(1px);
}

.product-item-see-prices-btn:disabled {
  border-color: #a987f2;
  background-color: #a987f2;
  cursor: not-allowed;
  opacity: 0.7;
}

.product-item-prices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-item-prices-aligned {
  display: grid;
  grid-template-rows: repeat(2, minmax(76px, auto));
}

.product-item-branch-wrapper {
  width: 100%;
  min-width: 0;
  grid-column: 1;
  container-type: inline-size;
}

.product-item-branch-wrapper-mga {
  grid-row: 1;
}

.product-item-prices-single .product-item-branch-wrapper-mga {
  grid-row: 2;
}

.product-item-branch-wrapper-itj {
  grid-row: 2;
}

.product-item-branch {
  position: relative;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  min-height: 76px;
  padding: 8px 10px;
  border: 1px solid;
  border-radius: 12px;
}

.product-item-branch-mga {
  border-color: #a8d9fb;
  background-color: #eef8ff;
  color: #0067a6;
}

.product-item-branch-itj {
  border-color: #ffc992;
  background-color: #fff6ed;
  color: #f26716;
}

.product-item-branch-info {
  display: flex;
  min-width: 80px;
  flex: 1 1 90px;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
}

.product-item-tax {
  min-height: 12px;
  color: #8da0b8;
  font-size: 10px;
  font-weight: 600;
}

.product-item-price {
  margin-top: 2px;
  color: inherit;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.product-item-stock {
  margin-top: 8px;
  color: #8da0b8;
  font-size: 12px;
  white-space: nowrap;
}

.product-item-stock strong {
  color: #263a5c;
  font-weight: 600;
}

.product-item-quantity {
  width: 80px;
  min-width: 48px;
  max-width: 80px;
  height: 36px;
  flex: 0 1 80px;
  padding: 0 6px;
  border: 1px solid #c7d3e0;
  border-radius: 11px;
  outline: 0;
  background-color: #fff;
  color: #8b98aa;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  appearance: textfield;
}

.product-item-quantity:focus {
  border-color: currentColor;
  box-shadow: 0 0 0 2px rgba(0, 117, 235, 0.12);
}

.product-item-quantity::-webkit-inner-spin-button,
.product-item-quantity::-webkit-outer-spin-button {
  margin: 0;
  appearance: none;
}

.product-item-cart {
  display: flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 11px;
  color: #fff;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.15s ease;
}

.product-item-cart:hover {
  filter: brightness(0.94);
}

.product-item-cart:active {
  transform: scale(0.96);
}

.product-item-cart:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.product-item-cart-mga {
  background-color: #0087cb;
}

.product-item-cart-itj {
  background-color: #ff6d13;
}

.product-item-branch-name {
  position: absolute;
  right: 14px;
  bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  opacity: 0.55;
}

.consulte-nos {
  display: flex;
  height: 3.7em;
  align-items: center;
  justify-content: center;
}

.consulte-nos.product-item-branch {
  height: auto;
}

.produto-favorito-div {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.produto-favorito-btn {
  position: relative;
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8e4f0;
  border-radius: var(--product-card-radius);
  background-color: #fff;
  cursor: pointer;
  padding: 0;
  appearance: none;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.produto-favorito-btn:focus,
.produto-favorito-btn:focus-visible,
.produto-favorito-btn:active {
  border-color: #d8e4f0;
  box-shadow: none;
  outline: 0;
}

.produto-favorito-btn-active,
.produto-favorito-btn-active:focus,
.produto-favorito-btn-active:focus-visible,
.produto-favorito-btn-active:active {
  border-color: #ffd867;
  background-color: #fff9e8;
}

.produto-favorito-icon {
  display: block;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin: 0;
  fill: #fff;
  stroke: #8da0b8;
  stroke-width: 1.35;
  stroke-linejoin: round;
  transition: all 0.2s;
}

.produto-favorito-btn:hover .produto-favorito-icon,
.produto-favorito-btn-active .produto-favorito-icon {
  fill: #f6c33f;
  stroke: #f6c33f;
}

@container (max-width: 215px) {
  .product-item-branch {
    gap: 6px;
    padding-right: 8px;
    padding-left: 8px;
  }

  .product-item-branch-info {
    min-width: 74px;
    flex-basis: 80px;
  }

  .product-item-price {
    font-size: 13px;
  }

  .product-item-cart {
    width: 34px;
    flex-basis: 34px;
  }

  .product-item-branch-name {
    right: 10px;
  }
}

@container (max-width: 275px) {
  .product-item-branch {
    flex-wrap: wrap;
    min-height: 108px;
  }

  .product-item-branch-info {
    min-width: 100%;
    flex-basis: 100%;
  }

  .product-item-quantity {
    max-width: none;
    flex: 1 1 auto;
  }

  .product-item-branch-name {
    top: 8px;
    right: 8px;
    bottom: auto;
  }
}
</style>
<script>
import Produto from "@/services/produto";
import ServicoBuscaTracking from "@/services/servicoBuscaTracking";
import { mapState } from "vuex";
import GrupoPermissao from "../../../services/grupoPermissao";
import Analytics from "@/services/analytics";
import { formatQuantity, parseQuantity } from "@/shared/utils";

export default {
  name: "ProductItem",
  props: {
    id: {
      type: String,
      default: "ProductItem",
    },
    codigo: {
      type: Number,
      default: 0,
    },
    multiplo: {
      type: Number,
      default: 1,
    },
    valor_unitario: {
      type: Number,
      default: 0,
    },
    marca: {
      type: String,
      default: "",
    },
    categoria: {
      type: String,
      default: "",
    },
    cliente_codigo: {
      type: Number,
      default: 0,
    },
    titulo: {
      type: String,
      default: "",
    },
    url_foto: {
      type: String,
      default: "",
    },
    tipo_origem_produto: {
      type: String,
      default: "",
    },
    estoques: {
      type: Array,
      default: [],
    },
    cd_filial: {
      type: Number,
      default: 0,
    },
    valida_estoque: {
      type: String,
      default: "N",
    },
    favorito: {
      type: Number,
      default: 0,
    },
    termoBusca: {
      type: String,
      default: "",
    },
    posicaoProduto: {
      type: Number,
      default: null,
    },
    trackingAtivo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingPrices: false,
      valor: [],
      valor_st: [],
      valor_ipi: [],
      pc_st: [],
      pc_ipi_st: [],
      pc_ipi: [],
      urlProdutoLoja: process.env.VUE_APP_LOJA,
      exibePrecoItj: false,
      exibePrecoMga: false,
      quantidadeMga: this.multiplo,
      quantidadeItj: this.multiplo,
      confirmMga: false,
      confirmItj: false,
      disabled: false,
      favoritoPending: false,
    };
  },
  mounted() {
    if (this.$route.meta.permissaoUrl !== "/vendas/produtos") {
      this.validaPermissao();
    }
    this.getPrices();
  },
  watch: {
    cliente_codigo() {
      this.getPrices();
    },
  },
  computed: {
    ...mapState("carrinho", {
      clienteCodigo: "cliente_codigo",
    }),
    ...mapState("carrinhoitj", {
      clienteCodigo: "cliente_codigo",
    }),
    temCliente() {
      if (
        this.$store.state.carrinho.cliente_codigo == null &&
        this.$store.state.carrinhoitj.cliente_codigo == null
      ) {
        return false;
      }

      return true;
    },
    temFilialMga() {
      return this.cd_filial == 1 || this.cd_filial == 0;
    },
    temFilialItj() {
      return this.cd_filial == 2 || this.cd_filial == 0;
    },
    temLinhaCarrinhoMga() {
      if (!this.temFilialMga) return false;

      const exibeCarrinho =
        (!this.loadingPrices && this.canAdd(1) && this.exibePrecoMga) ||
        (this.valida_estoque == "S" && this.exibePrecoMga);
      const exibeIndisponivel =
        !this.loadingPrices &&
        !this.canAdd(1) &&
        this.exibePrecoMga &&
        this.canAdd(2);

      return exibeCarrinho || exibeIndisponivel;
    },
    temLinhaCarrinhoItj() {
      if (!this.temFilialItj) return false;

      const exibeCarrinho =
        (this.canAdd(2) && !this.loadingPrices && this.exibePrecoItj) ||
        (this.valida_estoque == "S" && this.exibePrecoItj);
      const exibeIndisponivel =
        !this.loadingPrices &&
        !this.canAdd(2) &&
        this.exibePrecoItj &&
        this.canAdd(1);

      return exibeCarrinho || exibeIndisponivel;
    },
    precoCarrinhoMga() {
      return (
        (Number(this.valor.maringa) || 0) +
        (Number(this.valor_st.maringa) || 0) +
        (Number(this.valor_ipi.maringa) || 0)
      );
    },
    precoCarrinhoItj() {
      return (
        (Number(this.valor.itj) || 0) +
        (Number(this.valor_st.itj) || 0) +
        (Number(this.valor_ipi.itj) || 0)
      );
    },
    urlProduto() {
      const urlBase = String(this.urlProdutoLoja || "").replace(/\/+$/, "");
      return `${urlBase}/${this.tituloLinkLoja()}/${this.codigo}/p`;
    },
    precoTracking() {
      const exibeMaringa =
        this.temFilialMga &&
        ((!this.loadingPrices && this.canAdd(1) && this.exibePrecoMga) ||
          (this.valida_estoque == "S" && this.exibePrecoMga));

      if (exibeMaringa) {
        return Number(this.valor.maringa) || 0;
      }

      const exibeItajai =
        this.temFilialItj &&
        ((!this.loadingPrices && this.canAdd(2) && this.exibePrecoItj) ||
          (this.valida_estoque == "S" && this.exibePrecoItj));

      if (exibeItajai) {
        return Number(this.valor.itj) || 0;
      }

      return 0;
    },
  },
  methods: {
    formatQuantity,
    onQuantityInput(event, property) {
      const quantity = parseQuantity(event.target.value);
      this[property] = quantity;
      event.target.value = formatQuantity(quantity);
    },
    registrarSelecaoProduto() {
      this.trackSelectItem();
      if (!this.trackingAtivo) return;
      ServicoBuscaTracking.enviarClick({
        evento: Analytics.buildClickEvent({
          codigoProduto: this.codigo,
          preco: this.precoTracking,
          termo: this.termoBusca,
        }),
        urlProduto: this.urlProduto,
        tipoPagina: "search",
        feature: "search",
        posicaoProduto: this.posicaoProduto,
      });
    },
    registrarCarrinho(precoProduto) {
      if (!this.trackingAtivo) return;
      ServicoBuscaTracking.enviarClick({
        evento: Analytics.buildClickEvent({
          codigoProduto: this.codigo,
          preco: precoProduto,
          termo: this.termoBusca,
        }),
        urlProduto: this.urlProduto,
        tipoPagina: "cart",
        feature: "search",
        posicaoProduto: this.posicaoProduto,
      });
    },
    validaPermissao() {
      GrupoPermissao.getPermissao("/vendas/produtos").then((response) => {
        if (!response.data.data) this.$router.push("/");
        else this.disabled = response.data.data.edita != "1";
      });
    },
    getData(quantidade, filial) {
      const filialValor = filial == 1 ? "maringa" : "itj";
      let data = {
        codigo: this.codigo,
        multiplo: this.multiplo,
        titulo: this.titulo,
        tipo_origem_produto: this.tipo_origem_produto,
        estoque: this.estoques,
        quantidade: quantidade,
        cd_filial: filial,
        valor_unitario: this.valor[filialValor] || this.valor_unitario,
        valor_st: this.valor_st[filialValor] || 0,
        valor_ipi: this.valor_ipi[filialValor] || 0,
        marca: this.marca,
        categoria: this.categoria,
      };
      return data;
    },
    estoqueFilial(filial) {
      return this.estoques
        .filter((estoque) => estoque.codigo_filial == filial)
        .reduce(
          (total, estoque) => total + (Number(estoque.qt_estoque) || 0),
          0
        );
    },
    addMgaToCart() {
      this.addToCart(1, this.quantidadeMga, "confirmMga", "onAddMga");
    },
    addItjToCart() {
      this.addToCart(2, this.quantidadeItj, "confirmItj", "onAddItj");
    },
    addToCart(filial, quantidade, confirmationProperty, eventName) {
      if (Number(quantidade) <= 0) return;

      this.$emit(eventName, this.getData(quantidade, filial));
      this.registrarCarrinho(
        filial == 1 ? this.precoCarrinhoMga : this.precoCarrinhoItj
      );
      this[confirmationProperty] = true;
      setTimeout(() => {
        this[confirmationProperty] = false;
      }, 1500);
    },
    seeButton() {
      this.$emit("onAdd", false);
    },
    getPrices() {
      let cliente_codigo =
        this.$store.state.carrinho.cliente_codigo != null
          ? this.$store.state.carrinho.cliente_codigo
          : this.$store.state.carrinhoitj.cliente_codigo;

      if (cliente_codigo != null) {
        this.getValoresCliente(cliente_codigo);
      }
    },
    getValoresCliente(cliente_codigo) {
      this.loadingPrices = true;
      Produto.getValoresCliente(this.codigo, cliente_codigo)
        .then((response) => {
          if (response.data.data) {
            let values = response.data.data;
            if (Array.isArray(values)) {
              for (let i = 0; i < values.length; i++) {
                if (values[i].cdFilial == 1) {
                  this.preencheMaringa(values[i]);
                }

                if (values[i].cdFilial == 2) {
                  this.preencheItj(values[i]);
                }
              }

              if (
                values[0].valor_unitario == 0 &&
                values[1].valor_unitario == 0
              ) {
                this.$emit("onHideProduct", this.codigo);
              }
            } else {
              if (values.cdFilial == 1) {
                this.preencheMaringa(values);
              }

              if (values.cdFilial == 2) {
                this.preencheItj(values);
              }

              if (values.valor_unitario == 0) {
                this.$emit("onHideProduct", this.codigo);
              }
            }
          } else {
            this.$emit("onHideProduct", this.codigo);
          }
        })
        .catch((e) => {
          this.$emit("onHideProduct", this.codigo);
        })
        .finally(() => {
          this.loadingPrices = false;
        });
    },
    menorValor() {
      return this.multiplo;
    },
    preencheMaringa(values) {
      this.exibePrecoMga = true;
      this.valor.maringa = values.valor_unitario;
      this.valor_st.maringa = values.valor_st;
      this.valor_ipi.maringa = values.valor_ipi;
      this.pc_st.maringa = values.pc_icms;
      this.pc_ipi_st.maringa = 0;
      if (values.pc_st > 0) {
        this.pc_ipi_st.maringa = values.pcIpi + values.pc_st;
      } else {
        this.pc_ipi.maringa = values.pcIpi;
      }
    },
    preencheItj(values) {
      this.exibePrecoItj = true;
      this.valor.itj = values.valor_unitario;
      this.valor_st.itj = values.valor_st;
      this.valor_ipi.itj = values.valor_ipi;
      this.pc_st.itj = values.pc_icms;
      this.pc_ipi_st.itj = 0;
      if (values.pc_st > 0) {
        this.pc_ipi_st.itj = values.pcIpi + values.pc_st;
      } else {
        this.pc_ipi.itj = values.pcIpi;
      }
    },
    canAdd(filial) {
      let estoquesAux = [];
      for (let i = 0; i < this.estoques.length; i++) {
        if (this.estoques[i].codigo_filial == filial) {
          estoquesAux.push(this.estoques[i]);
        }
      }
      let estoque = estoquesAux.filter(
        (el) => el.qt_estoque > 0 && el.codigo_filial == filial
      );
      if (estoque.length == 0) {
        if (this.tipo_origem_produto != "NACIONAL") {
          return false;
        }
        return false;
      }

      return true;
    },
    alternarFavorito() {
      if (this.favoritoPending) {
        return;
      }

      if (this.favorito == 0) {
        this.favoritarProduto();
        return;
      }

      this.desfavoritarProduto();
    },
    favoritarProduto() {
      const favoritoAnterior = this.favorito;
      const favoritoProvisorio = -1;

      this.favoritoPending = true;
      this.$emit("onFavoritado", this.codigo, favoritoProvisorio);

      Produto.favoritar(this.codigo)
        .then((response) => {
          if (response.data.data) {
            const favoritoConfirmado = response.data.data;

            this.$emit("onFavoritado", this.codigo, favoritoConfirmado);
            this.$helper.showMsg("Favoritado", "success");
          } else {
            this.$emit("onFavoritado", this.codigo, favoritoAnterior);
          }
        })
        .catch(() => {
          this.$emit("onFavoritado", this.codigo, favoritoAnterior);
        })
        .finally(() => {
          this.favoritoPending = false;
        });
    },
    desfavoritarProduto() {
      const favoritoAnterior = this.favorito;

      this.favoritoPending = true;
      this.$emit("onFavoritado", this.codigo, 0);

      Produto.desfavoritar(favoritoAnterior)
        .catch(() => {
          this.$emit("onFavoritado", this.codigo, favoritoAnterior);
        })
        .finally(() => {
          this.favoritoPending = false;
        });
    },
    trackSelectItem() {
      Analytics.trackSelectItem({
        codigo: this.codigo,
        titulo: this.titulo,
        marca: this.marca,
        categoria: this.categoria,
      }, this.$store);
    },
    tituloLinkLoja(){
      return this.removerCharsNaoPermitidosURL(this.removerAcentos(this.titulo.replaceAll(' ', '-').toLowerCase()));
    },
    removerAcentos(string){
      return string.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, '');
    },
    removerCharsNaoPermitidosURL(string){
      return string.replace(/[^a-zA-Z0-9-_]/g, '');
    }
  },
};
</script>
